export default {
  // ContinueWithEmail / SignIn / SignUp
  signInToYour: `ログイン`,
  signInToUse: `ログイン`,
  createAnAccount: `アカウント作成`,
  createYour: `アカウント作成`,
  createAccountFor: `アカウント作成`,
  tmAccount: `トレンドマイクロアカウント`,
  toStartFreeTrial: `30日無料体験期間を開始する`,
  toStartUsing: `製品利用を開始する`,
  newUser: `新規登録の場合`,
  createAccount: `アカウントの作成`,
  email: `メールアドレス`,
  password: `パスワード`,
  confirmPassword: `パスワードの確認`,
  signIn: `ログイン`,
  alreadyHaveAccount: `アカウントをお持ちの場合`,
  forgotEmail: `メールアドレスをお忘れの場合`,
  forgetPassword: `パスワードをお忘れの場合`,
  incorrectEmailPassword: `メールアドレスまたはパスワードが正しくありません`,
  emailOrPhone: `メールアドレスまたは携帯電話番号`,
  next: `次へ`,
  noAccountYet: `アカウントをお持ちでない場合`,
  createNewAccount: `アカウントを作成`,
  continueWithOtherOptions: `他のアカウントを使用する`,
  continueAs: `{account}で続行`,
  continueWithOTP: `1回限りの確認コードで続行`,
  signUpAs: `{account}で登録`,
  signUpWithSocialGoogle: `Googleアカウントで登録`,
  signUpWithSocialApple: `Apple IDで登録`,
  signInWithSocialGoogle: `Googleアカウントでログイン`,
  signInWithSocialApple: `Apple IDでログイン`,
  signInAs: `{account}でログイン`,
  signInFailAs: `{account}でログインできません`,
  signUpWith: `{method} {email} で登録`,
  signInWith: `{method} {email} でログイン`,
  signInFailWith: `{method} {email}でログインできません`,
  signUpWithGoogle: `{method}アカウント {email} で登録`,
  signInWithGoogle: `{method}アカウント {email} でログイン`,
  signInFailWithGoogle: `{method}アカウント {email} でログインできません`,
  signInWithEmailOTP: `1回限りの確認コードでログイン`,
  usePasswordInstead: `代わりにパスワードを使用`,
  useAnotherEmail: `他のメールアドレスを使用する`,
  useAnotherPhoneNumber: `他の携帯電話番号を使用する`,
  useAnotherSignInMethod: `他のログイン方法を使用する`,
  useAnotherSignUpMethod: `他の登録方法を使用する`,
  useAnotherMethod: `他の登録方法を使用する`,
  show: `表示`,
  hide: `非表示`,
  phoneNumberFrom: `{country} (+{phoneCode}) の電話番号ですか?`,
  selectCountry: ``,
  sendSMSCode: `1回限りの確認コードを携帯電話番号に送信します。`,
  verifyCode: `本人確認のため、携帯電話番号に送信された確認コードを入力してください。`,
  verifyEmailCode: `本人確認のため、{email}に送信した確認コードを入力してください。`,
  confirmationCode: `確認コード`,
  haveSameEmail: `同じメールアドレスを使用したトレンドマイクロアカウントがすでに登録されています。`,
  enterYourPassword: `トレンドマイクロアカウントのパスワードを入力`,
  accountLinking: `アカウントを連携して簡単にログインするために、トレンドマイクロアカウントのパスワードを入力してください。`,
  completeProfile: `トレンドマイクロアカウントに登録する情報を入力してください。`,
  firstName: `氏名 (フリガナ)`,
  lastName: `氏名`,
  phoneNumber: `電話番号`,
  receiveNews: `トレンドマイクロから最新情報を受信する`,
  maybeLater: `後で`,
  chooseAccount: `ログインするアカウントを選択`,
  troubleSignIn: `ログインでお困りの場合`,
  accountDuplicate: `このメールアドレスはすでに使用されています。別のメールアドレスを使用するか、
  <span id="linkSignIn" class="link-tag">このメールアドレスでログイン</span>してください。`,
  emailAccountIsExisted: `このメールアドレスでアカウントがすでに作成されています。`,
  emailAccountIsNotExisted: `アカウントがまだ作成されていないか、このメールアドレスが正しくありません。`,
  smsAccountIsExisted: `この電話番号でアカウントがすでに作成されています。`,
  smsAccountIsNotExisted: `アカウントがまだ作成されていないか、この電話番号が正しくありません。`,
  signInWithThisEmail: `このメールアドレスでログイン`,
  signUpWithThisEmail: `このメールアドレスで新しいアカウントを作成`,
  signInWithThisSMS: `この電話番号でログイン`,
  signUpWithThisSMS: `この電話番号で新しいアカウントを作成`,
  accountNotExist: `このメールアドレスは登録されていません。他のメールアドレスをお試しください。`,
  phoneAccountDuplicate: `この電話番号はすでに使用されています。別の携帯電話番号を使用するか、<span id="linkSignIn" class="link-tag">この携帯電話番号でログイン</span>してください。`,
  phoneAccountNotExist: `この電話番号は登録されていません。別の携帯電話番号を使用するか、<span id="linkSignUp" class="link-tag">この携帯電話番号でアカウントを作成</span>してください。`,
  signInUnsuccess: `ログインに失敗しました`,
  noPasswordLoginInstruction: `他の方法でトレンドマイクロアカウントが作成されたため、トレンドマイクロアカウントのパスワードが設定されていません。
他のログイン方法をお試しいただくか、次の画面の [パスワードをお忘れの場合] の手順に従ってパスワードを設定してください。`,
  signInWithPhone: `携帯電話番号でログインする`,
  accountNotCreated: `このメールアドレスは登録されていません。`,
  createAccountOrSignIn: `すでにアカウントをお持ちの場合は<span id="linkChangeMethod" class="link-tag">他のログイン方法を使用</span>してください。アカウントをお持ちでない場合のみ、アカウントを作成してください。`,
  createAccountFailed: `アカウントの作成に失敗しました`,
  googleAccountExisted: `このGoogleアカウントはすでに使用されています。他のアカウントを使用してください。`,
  appleAccountExisted: `このApple IDはすでに使用されています。他のアカウントを使用してください。`,
  emailAccountExisted: `このメールアドレスはすでに使用されています。他のメールアドレスを使用してください。`,
  smsAccountExisted: `この電話番号はすでに使用されています。他の携帯電話番号を使用してください。`,
  googleAccountNotExised: `このGoogleアカウントは登録されていません。他のGoogleアカウントまたは別のログイン方法をお試しください。`,
  appleAccountNotExised: `このApple IDは登録されていません。他のApple IDまたは別のログイン方法をお試しください。`,
  emailAccountNotExisted: `このメールアドレスは登録されていません。他のメールアドレスをお試しください。`,
  smsAccountNotExisted: `この電話番号は登録されていません。他の携帯電話番号を使用してください。`,
  acceptAgreement: `{agreement1}および{agreement2}を読み、内容に同意します。`,

  // Error Messages
  incorrectPassword: `パスワードが正しくありません`,
  incorrectCode: `確認コードが正しいことを確認してください。または、[再送信] を選択して新しいコードを入手してください。`,
  socialLoginFail: `アカウント情報が一致しません。他のアカウントをお試しください。`,

  // TwoFactorAuth
  twoFactorAuth: `2要素認証`,
  verifyAuthApp: `本人確認のため、認証アプリに表示された確認コードを入力してください。`,
  verifySms: `本人確認のため、{userSms}に送信された確認コードを入力してください。`,
  verifyEmail: `本人確認のため、{userEmail}に送信された確認コードを入力してください。`,
  notReceiveCode: `確認コードが届きませんか? `,
  upperContactSupport: `サポートにお問い合わせください。`,
  upperChooseAnotherMethod: `別の方法を選択してください。`,
  resend: `再送信`,
  or: `するか、`,
  lowerContactSupport: `サポートにお問い合わせください。`,
  lowerChooseAnotherMethod: `別の方法を選択してください。`,
  codeSent: `コードが送信されました。`,

  // ChooseAnotherMethod
  selectMethod: `方法を選択`,
  authApp: `認証アプリ`,
  receiveAuthApp: `認証アプリで確認コードを受信してください。`,
  sms: `テキストメッセージ (SMS)`,
  receiveSms: `{userSms}に送られた確認コードを確認してください。`,
  emailAddress: `メールアドレス`,
  receiveEmailAddress: `{userEmail}に送られた確認コードを確認してください。`,
  continue: `続行`,

  doUse: `推奨するパスワード`,
  dontUse: `推奨しないパスワード`,
  labelOK: `OK`,
  contactSupport: `ご不明な点は<a id="contactSupport" class="link-tag">サポートへお問い合わせください</a>。`,

  validationRules: {
    birthDayIncorrect: "誕生日の形式が正しくありません。",
    birthMonthIncorrect: "誕生月の形式が正しくありません。",
    birthYearIncorrect: "誕生年の形式が正しくありません。",
    CHECK_EMAIL: "正しい形式でメールアドレスを入力してください。",
    CHECK_MERGE_EMAIL: "正しい形式でメールアドレスを入力してください。",
    CHECK_MERGE_SN: "アカウントの正しいシリアル番号とパスワードを入力してください。",
    CHECK_PASSWORD_LENGTH: "8～50文字で設定してください。",
    CHECK_PASSWORD_FORMAT: "新しいパスワードは大文字と小文字を区別し、8～50文字で設定してください。英数字と記号 ({PASSWORDSYMBOLS}) を使用できます。",
    PASSWORD_LENGTH_FAIL: "パスワードは8～50文字で設定してください。",
    PASSWORD_COMPLEXITY_FAIL: `一般的な単語や名前、「qwerty」などのキーボード上で連続している文字列は使用しないでください。`,
    checkFax: "FAX番号を確認してください。",
    checkFirstName: "次の記号、< > &は使用しないでください。",
    checkLastName: "次の記号、< > &は使用しないでください。",
    checkPhone: "電話番号を確認してください。",
    checkZipCode: "郵便番号を確認してください。",
    EMAIL_NOT_MATCH: "メールアドレスが一致しません。",
    FIELD_REQUIRED: "このフィールドに入力してください。",
    PASSWORD_NOT_MATCH: "パスワードが一致しません。やりなおしてください。",
    snIncorrect: "入力されたログイン情報が正しくありません。もう一度確認してください。",
  },
  passwordRules: {
    title: `パスワードは次の条件を満たすことが推奨されます。`,
    rule1: `8～50文字`,
    rule2: `大文字と小文字を含む`,
    rule3: `1つ以上の記号と数字を含む`,
    rule4: `「qwerty」などのキーボード上で連続している文字列だけをパスワードに使用しない`,
    tip: `強力なパスワードを作成するには?`
  },
  passwordTips: {
    title: `強力なパスワードを作成するには?`,
    tipMsg: `覚えやすく、解読されにくいパスワードを作成するには、次のヒントを参考にしてください。`,
    tipGood1: `本や歌などに出てくる意味のあるフレーズ`,
    tipGood2: `関連のない単語、数字、および記号`,
    tipBad1: `「password」などの一般的な単語やフレーズ`,
    tipBad2: `「abcd」や「1234」などの連続した文字列`,
    tipBad3: `「qwerty」などのキーボード上で連続している文字列`,
    example: `たとえば、覚えやすい文字列の一部を、他の文字、記号、数字に置き換えたパスワード (例: さんぽにいく→ sanpo-ni-iku → s@np0-2-1ku)`,
  },
  passwordStrength: {
    description: {
        good: "文字、数字、記号のランダムな組み合わせを追加すると、さらに強力になります。",
        short: "8～50文字で設定してください。",
        strong: "パスワードを安全に保つためには、大切に保管し、使いまわしをしないでください。",
        weak: "パスワードを強力にするには、ランダムな文字、数字、記号を組み合わせて、50文字以内で設定してください。"
    },
    level: {
        good: "強度: 中",
        short: "短すぎます",
        strong: "強度: 高",
        weak: "強度: 低"
    }
  },
  emailVerification: {
    linkExipredTitle: `有効期限が切れています`,
    linkExipredContent: `確認メールを再送信するには、下のボタンをクリックしてください。`,
    btnResendVerificationMail: `確認メールを送信`,
    linkSentTitle: `次のメールアドレスに確認メールを送信しました`,
    linkSentContent: `メールに記載された手順に従って、メールアドレスを確認してください。メールが見つからない場合、迷惑メールフォルダに振り分けられている可能性があります。`,
    didnotReceiveEmail: `メールが届きませんか?`,
    verifySuccessTitle: `メールアドレスが確認されました `,
    verifySuccessContent: `この画面は閉じて構いません。`,
    verifyLater: `後で確認`,
    verifyEmailAddrTitle: `メールアドレスを確認してください`,
    verifyEmailAddrContent: `お客さま本人のメールアドレスであることを確認するため、トレンドマイクロから送信されたメールに記載されている確認コードを入力するか、メール上のボタンをクリックしてください。`,
  },

  errorMsg: {
    serverError: `確認コードが送信できませんでした`,
  }
};
